//  文本输入组件
const StaticInput = (attrs) => {
  return <ElInput {...attrs.data} size='mini' />;
};
// 下拉组件
export const FSelect = (arg) => {
  const { data: { attrs: { list = [], ...props }, ...data }} = arg;
  return (
    <ElSelect {...{ ...data, attrs: props }} filterable={true} size='mini'>
      {list.map(({ id, cnName }) => (
        <ElOption label={cnName} value={id} key={id} />
      ))}
    </ElSelect>
  );
};
//  数字输入组件
const NumberInput = (attrs) => {
  return (<ElInputNumber class='width-full' {...attrs.data} size='mini' controls-position='right' />);
};
// 限定整数输入
const IntNumberInput = (attrs) => {
  return (
    <NumberInput {...attrs.data} precision={0} />
  );
};
// 日期时间
const DateInput = (attrs) => {
  return (
    <ElDatePicker
      {...attrs.data}
      value-format='yyyy-MM-dd HH:mm:ss'
      type='datetime'
      size='mini'
      placeholder='选择日期' />
  );
};
// 仅时间
const TimeInput = (attrs) => {
  return (
    <ElTimePicker
      {...attrs.data}
      size='mini'
      value-format='HH:mm:ss'
      type='time'
      placeholder='选择时间' />
  );
};
// 当前所有的类型组件
export const TypeMap = {
  string: {
    id: 'string',
    input: StaticInput,
    cnName: '字符串'
  },
  field: {
    id: 'field', // 实际提交数据没有这个id, 选择它时需要valueSource改为2
    input: FSelect,
    cnName: '主表字段'
  },
  subField: {
    id: 'subField', // 实际提交数据没有这个id, 选择它时需要valueSource改为3
    input: FSelect,
    cnName: '从表字段'
  },
  int: {
    id: 'int',
    input: IntNumberInput,
    cnName: '整数'
  },
  decimal: {
    id: 'decimal',
    input: NumberInput,
    cnName: '小数'
  },
  dateTime: {
    id: 'dateTime',
    input: DateInput,
    cnName: '时间日期'
  },
  time: { id: 'time', input: TimeInput, cnName: '时间' },
  list: {
    id: 'list',
    input: StaticInput,
    cnName: '数组（其中每一项为字符串）'
  }
};
// 运算符
// valueType 后面可以显示类型的组件,为空则不显示组件
// value2 是否显示第二个输入框
export const operators = [
  {
    id: "=", cnName: "=", valueType: [TypeMap.string, TypeMap.field, TypeMap.subField, TypeMap.int, TypeMap.decimal, TypeMap.dateTime, TypeMap.time]
  },
  { id: "!=", cnName: "≠", valueType: [TypeMap.string, TypeMap.field, TypeMap.subField, TypeMap.int, TypeMap.decimal, TypeMap.dateTime, TypeMap.time] },
  { id: ">", cnName: ">", valueType: [TypeMap.string, TypeMap.field, TypeMap.subField, TypeMap.int, TypeMap.decimal, TypeMap.dateTime, TypeMap.time] },
  { id: ">=", cnName: "≥", valueType: [TypeMap.field, TypeMap.subField, TypeMap.int, TypeMap.decimal] },
  { id: "<", cnName: "<", valueType: [TypeMap.field, TypeMap.subField, TypeMap.int, TypeMap.decimal] },
  { id: "<=", cnName: "≤", valueType: [TypeMap.field, TypeMap.subField, TypeMap.int, TypeMap.decimal] },
  { id: 'like', cnName: '包含', valueType: [TypeMap.string, TypeMap.field, TypeMap.subField, TypeMap.int, TypeMap.decimal] },
  { id: 'notLike', cnName: '不包含', valueType: [TypeMap.string, TypeMap.field, TypeMap.subField, TypeMap.int, TypeMap.decimal] },
  // { id: 'some', cnName: '包含任意一个', valueType: [TypeMap.string, TypeMap.field,TypeMap.subField, TypeMap.int, TypeMap.decimal] },
  // { id: 'any', cnName: '包含所有', valueType: [TypeMap.string, TypeMap.field,TypeMap.subField, TypeMap.int, TypeMap.decimal] },
  { id: 'isNull', cnName: '为空', valueType: [] },
  { id: 'notNull', cnName: '不为空', valueType: [] },
  { id: 'in', cnName: '等于任意一个', valueType: [TypeMap.string, TypeMap.field, TypeMap.subField, TypeMap.int, TypeMap.decimal] },
  { id: 'notin', cnName: '不等于任意一个', valueType: [TypeMap.string, TypeMap.field, TypeMap.subField, TypeMap.int, TypeMap.decimal] },
  { id: 'minMax', cnName: '数值范围', valueType: [TypeMap.int, TypeMap.decimal, TypeMap.field], value2: true },
  { id: 'timeBetween', cnName: '时间范围', valueType: [TypeMap.time, TypeMap.field], value2: true },
  { id: 'dateBetween', cnName: '日期范围', valueType: [TypeMap.dateTime, TypeMap.field], value2: true },
  { id: 'isBlank', cnName: '(字符串)为空', valueType: [] },
  { id: 'notBlank', cnName: '(字符串)不为空', valueType: [] }
];
// 全局字段
export const globalValue = [
  { id: "{@enterpriseId}", cnName: "当前企业" },
  { id: "{@prjId}", cnName: "当前项目" },
  { id: "{@currentUserId}", cnName: "当前用户" }
];
// 条件运算符
export const andOr = [{ id: "or", cnName: "或" }, { id: "and", cnName: "且" }];
